import { FC } from "react";
import ValidOTP from "./ValidOTP";
import InvalidOTP from "./InValidOTP";
import AuthTitleAndDescription from "../../AuthTitleAndDescription";
import { useIntl } from "react-intl";

interface HeadWrapperProps {
  isCodeWrong: null | boolean;
}

const HeadWrapper: FC<HeadWrapperProps> = ({ isCodeWrong }) => {
  const intl = useIntl();
  const titleAndDescription = {
    title: intl.formatMessage({ id: "almostDoneWithLookfindr" }),
    description: intl.formatMessage({ id: "otpSentDescription" }),
  };

  return (
    <div className="text-center">
      {isCodeWrong === null ? (
        <div className="space-y-4">
          <AuthTitleAndDescription titleAndDescription={titleAndDescription} />
        </div>
      ) : (
        <div className="">
          {isCodeWrong === false ? <ValidOTP /> : <InvalidOTP />}
        </div>
      )}
    </div>
  );
};

export default HeadWrapper;
